import { RecommendationIntent } from '@coach-bot/data-access/shared/enums';
import { Recommendation } from '@coach-bot/data-access/shared/interfaces';

export function getRecommendationResourceIds(recommendation: Recommendation): [string | undefined, string | undefined] {
  let learningResourceId: string | undefined;
  let placementQuizId: string | undefined;
  if (recommendation) {
    if (recommendation.intent === RecommendationIntent.Learn) {
      learningResourceId = recommendation.id;
    } else if (recommendation.intent === RecommendationIntent.Test) {
      if (recommendation.isPlacementTest) {
        placementQuizId = recommendation.id;
      }
    }
  }
  return [learningResourceId, placementQuizId];
}
